import React from "react";
import Layout from "./components/Layout";
import Banner from "./components/Banner";
import About from "./components/About";
import Questions from "./components/Questions";
import Costumers from "./components/Costumers";
import Promote from "./components/Promote";
import Contact from "./components/Contact";

import "./styles/components/app.sass";

function App() {
  return (
    <Layout>
      <Banner />
      <About />
      <Questions />
      <Costumers />
      <Promote />
      <Contact />
    </Layout>
  );
}

export default App;
